var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyLive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 233,
  height: 232,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h233v232H0z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 116,
  cy: 116.001,
  fill: "#F8F8F8",
  rx: 97.305,
  ry: 99.474
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A2A2A2",
  d: "M65.604 56.049c-1.107-1.912-3.704-2.323-4.916-.476-1.39 2.118-2.358 4.632-2.8 7.342a20.8 20.8 0 0 0 .44 8.731c.532 1.963 2.886 2.504 4.501 1.268 1.246-.953 1.584-2.658 1.247-4.19a11.5 11.5 0 0 1-.115-4.317 10.7 10.7 0 0 1 1.272-3.617c.843-1.455 1.213-3.285.37-4.741M101.745 46.1c-1.107-1.912-3.704-2.323-4.915-.476-1.39 2.118-2.358 4.631-2.8 7.342a20.8 20.8 0 0 0 .44 8.73c.532 1.964 2.886 2.505 4.501 1.269 1.246-.954 1.584-2.658 1.247-4.19a11.5 11.5 0 0 1-.115-4.317 10.7 10.7 0 0 1 1.272-3.617c.843-1.456 1.213-3.286.37-4.741M137.887 37.576c-1.107-1.911-3.704-2.323-4.915-.476-1.39 2.119-2.358 4.632-2.8 7.342a20.76 20.76 0 0 0 .439 8.731c.533 1.963 2.887 2.505 4.502 1.268 1.246-.953 1.584-2.657 1.247-4.19a11.6 11.6 0 0 1-.116-4.317 10.7 10.7 0 0 1 1.273-3.616c.842-1.456 1.213-3.286.37-4.742"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  stroke: "#B1B5B5",
  strokeWidth: 2.108,
  d: "M153.813 55.756c4.762-1.316 9.671 1.551 10.865 6.345l21.657 87.005a8.784 8.784 0 0 1-6.184 10.588L74.017 189.029c-4.762 1.316-9.671-1.551-10.865-6.344L41.495 95.68a8.785 8.785 0 0 1 6.184-10.59z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#B1B5B5",
  strokeWidth: 2.108,
  d: "M160.764 41.549c4.761-1.316 9.671 1.551 10.864 6.345l21.657 87.005a8.783 8.783 0 0 1-6.183 10.588L80.967 174.822c-4.761 1.316-9.671-1.551-10.864-6.344L48.446 81.473a8.785 8.785 0 0 1 6.183-10.59z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  stroke: "#B1B5B5",
  strokeWidth: 2.108,
  d: "M160.669 41.575c4.794-1.325 9.73 1.591 10.884 6.429l4.348 18.225L53.497 99.783l-4.858-18.21a8.785 8.785 0 0 1 6.146-10.732z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#A2A2A2",
  d: "M109.451 69.12c.303 2.165 2.424 3.644 4.299 2.523a14 14 0 0 0 2.771-2.19c1.872-1.9 3.305-4.368 4.157-7.158a20.7 20.7 0 0 0 .698-8.747c-.394-2.94-1.409-5.703-2.944-8.012-1.536-2.31-3.538-4.085-5.807-5.15-2.268-1.064-4.725-1.38-7.125-.917-2.399.463-4.658 1.689-6.551 3.556-1.287 1.27-2.374 2.804-3.215 4.529-.694 1.42.038 3.066 1.463 3.749 1.735.83 3.77-.129 4.975-1.628a9 9 0 0 1 .658-.729c1.05-1.035 2.302-1.715 3.632-1.972a6.4 6.4 0 0 1 3.951.51c1.258.59 2.368 1.574 3.219 2.854s1.414 2.812 1.633 4.443c.218 1.63.085 3.302-.388 4.85-.472 1.547-1.266 2.915-2.304 3.968a8 8 0 0 1-.498.465c-1.505 1.29-2.899 3.093-2.624 5.057M73.31 79.07c.302 2.164 2.423 3.644 4.298 2.523a14 14 0 0 0 2.771-2.19c1.872-1.9 3.305-4.368 4.157-7.159a20.7 20.7 0 0 0 .698-8.747c-.394-2.94-1.409-5.703-2.944-8.012-1.536-2.31-3.538-4.084-5.806-5.149-2.27-1.064-4.726-1.381-7.125-.918s-4.659 1.69-6.552 3.556c-1.287 1.27-2.373 2.805-3.215 4.53-.694 1.42.038 3.065 1.464 3.748 1.734.83 3.77-.128 4.974-1.628q.311-.386.658-.729c1.05-1.035 2.302-1.715 3.633-1.972a6.4 6.4 0 0 1 3.95.51c1.258.59 2.368 1.574 3.22 2.854.85 1.28 1.413 2.812 1.632 4.443s.085 3.302-.387 4.85-1.267 2.915-2.305 3.968a8 8 0 0 1-.498.465c-1.505 1.29-2.899 3.093-2.624 5.057M145.593 60.598c.302 2.163 2.424 3.643 4.299 2.522a14 14 0 0 0 2.771-2.19c1.871-1.9 3.305-4.368 4.156-7.159a20.7 20.7 0 0 0 .699-8.747c-.394-2.94-1.409-5.702-2.945-8.012-1.535-2.309-3.537-4.084-5.806-5.149-2.269-1.064-4.725-1.38-7.125-.918-2.399.463-4.658 1.69-6.551 3.557-1.287 1.269-2.374 2.804-3.216 4.529-.693 1.42.039 3.065 1.464 3.748 1.735.831 3.77-.128 4.975-1.627a9 9 0 0 1 .658-.73c1.049-1.035 2.302-1.714 3.632-1.971a6.4 6.4 0 0 1 3.951.509c1.258.59 2.368 1.575 3.219 2.855s1.414 2.812 1.633 4.442c.218 1.63.085 3.303-.388 4.85-.472 1.547-1.267 2.915-2.304 3.969a8 8 0 0 1-.498.465c-1.506 1.29-2.899 3.093-2.624 5.057"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__a)",
  strokeWidth: 0.422,
  d: "M0-.211h109.779",
  opacity: 0.4,
  transform: "matrix(.96234 -.27184 .26093 .96536 65.958 110.316)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__b)",
  strokeWidth: 0.422,
  d: "M0-.211h109.779",
  opacity: 0.4,
  transform: "matrix(.96234 -.27184 .26093 .96536 75.688 121.684)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__c)",
  strokeWidth: 0.422,
  d: "M0-.211h109.779",
  opacity: 0.4,
  transform: "matrix(.96234 -.27184 .26093 .96536 77.078 137.316)"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__d)",
  strokeWidth: 0.422,
  d: "M0-.211h109.779",
  opacity: 0.4,
  transform: "matrix(.96234 -.27184 .26093 .96536 75.688 155.789)"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__e)",
  strokeWidth: 0.422,
  d: "M0-.211h50.426",
  opacity: 0.4,
  transform: "matrix(-.2728 -.96207 .95879 -.28412 97.997 143.516)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__f)",
  strokeWidth: 0.422,
  d: "M0-.211h50.426",
  opacity: 0.4,
  transform: "matrix(-.2728 -.96207 .95879 -.28412 123.018 137.832)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#empty-live_svg__g)",
  strokeWidth: 0.422,
  d: "M0-.211h50.426",
  opacity: 0.4,
  transform: "matrix(-.2728 -.96207 .95879 -.28412 149.429 129.305)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "m97.57 125.839 62.208-17.446a8.43 8.43 0 0 1 10.457 6.07l12.489 49.851s7.896.799 9.73 9.237c.54 2.485-.074 4.864-1.028 6.843-1.861 3.862-5.999 5.807-10.144 6.902l-55.551 14.676a26 26 0 0 1-3.091.289c-12.374.376-17.313-14.139-20.452-26.114l-10.497-40.051a8.43 8.43 0 0 1 5.88-10.257"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#B2B2B2",
  strokeWidth: 2.811,
  d: "M182.724 164.314s7.896.799 9.73 9.237c.54 2.485-.074 4.864-1.028 6.843-1.861 3.862-5.999 5.807-10.144 6.902l-55.551 14.676a26 26 0 0 1-3.091.289c-12.374.376-17.313-14.139-20.452-26.114l-10.497-40.051a8.43 8.43 0 0 1 5.88-10.257l62.207-17.446a8.43 8.43 0 0 1 10.457 6.07zm-56.993 37.658c7.067-2.42 11.109-8.755 10.425-16.342-.777-8.632-16.681-13.5-15.291-13.5 24.341 0 61.859-7.816 61.859-7.816"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  stroke: "#B2B2B2",
  strokeWidth: 1.405,
  d: "M136.156 185.632c.684 7.587-3.358 13.923-10.425 16.342l55.551-14.676c4.145-1.095 8.283-3.04 10.144-6.902.953-1.979 1.568-4.357 1.028-6.843-1.834-8.438-9.731-9.237-9.731-9.237s-37.517 7.816-61.858 7.816c-1.39 0 14.513 4.868 15.291 13.5Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#B2B2B2",
  strokeLinecap: "round",
  strokeWidth: 1.405,
  d: "m121.561 160.052 36.836-10.657M110.44 138.994l13.901 6.53m-3.382-9.602-6.762 13.442M143.802 129.022l13.9 6.529m-3.381-9.602-6.762 13.443"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3F3F3",
  stroke: "#B1B5B5",
  strokeWidth: 1.091,
  d: "M30.511 149.119a9.18 9.18 0 0 0 5.782 5.777 9.17 9.17 0 0 0-5.782 5.775 9.17 9.17 0 0 0-5.783-5.775 9.18 9.18 0 0 0 5.783-5.777ZM205.66 75.225A9.17 9.17 0 0 0 211.442 81a9.18 9.18 0 0 0-5.782 5.775 9.18 9.18 0 0 0-5.783-5.775 9.18 9.18 0 0 0 5.783-5.776Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__a",
  x1: 0,
  x2: 109.779,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__b",
  x1: 0,
  x2: 109.779,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__c",
  x1: 0,
  x2: 109.779,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__d",
  x1: 0,
  x2: 109.779,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__e",
  x1: 0,
  x2: 50.426,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__f",
  x1: 0,
  x2: 50.426,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-live_svg__g",
  x1: 0,
  x2: 50.426,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A2A2A2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#A2A2A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2A2A2",
  stopOpacity: 0
})))));
export { SvgEmptyLive as ReactComponent };
export default __webpack_public_path__ + "c5cbec0c40f0dc5793aee9c66eb8d8cf.svg";